export default "__VITE_ASSET__8cd59e2d__"